import {getSectionsSourceLayer, mapIdsToValueStyle} from '../helper-functions/mapbox_helpers';
import {
  COLOR_AVAILABLE_SECTION,
  LAYER_SECTIONS_SOURCE,
  LAYER_SECTIONS_OUTLINE_ID,
  LAYER_SECTIONS_HIGHLIGHTED,
  LAYER_SECTIONS_GA,
  LAYER_SECTIONS_HOVERED,
} from '../mapbox-constants/mapbox_constants';
const colorRGBA = (alpha = 1) => `rgba(209, 220, 229, ${alpha})`;

const COLOR_SELECTED_OUTLINE = 'rgba(0, 0, 0, 0.5)';
const COLOR_OUTLINE_DEFAULT = 'rgba(209, 220, 229, .1)';
const DEFAULT_FILL_OPACITY = 0.5;

const DEFAULT_LINE_WIDTH = 0;
const SELECTED_LINE_WIDTH_BASE = 0.8;
const SELECTED_LINE_WIDTH_ZOOM = 5;
const SELECTED_LINE_MIN_ZOOM = 8;
const SELECTED_LINE_MAX_ZOOM = 13;

const DEFAULT_HOVER_OPACITY = 0;
const DEFAULT_HOVER_COLOR = '#000';
const HOVER_OPACITY = 0.3;

const SECTION_LINE_PAINT = {
  'line-color': {
    stops: [
      [8, colorRGBA(1)],
      // eslint-disable-next-line no-magic-numbers
      [14.2, colorRGBA(0.1)],
    ],
  },
  'line-width': DEFAULT_LINE_WIDTH,
};

function LayerSectionsOutline(sectionsConfig, venueConfigId) {
  return {
    id: LAYER_SECTIONS_OUTLINE_ID,
    type: 'line',
    visibility: 'visible',
    source: LAYER_SECTIONS_SOURCE,
    minzoom: sectionsConfig.ZOOM_MIN_SECTIONS,
    'source-layer': getSectionsSourceLayer(venueConfigId),
    'line-join': 'round',
    paint: SECTION_LINE_PAINT,
  };
}

function LayerSectionsHover(sectionsConfig, venueConfigId) {
  return {
    id: LAYER_SECTIONS_HOVERED,
    type: 'fill',
    source: LAYER_SECTIONS_SOURCE,
    minzoom: sectionsConfig.ZOOM_MIN_SECTIONS,
    'source-layer': getSectionsSourceLayer(venueConfigId),
    paint: {
      'fill-opacity': DEFAULT_HOVER_OPACITY,
      'fill-color': DEFAULT_HOVER_COLOR,
    },
  };
}

function LayerSections(
  sectionsConfig,
  venueConfigId,
  unavailableColor,
  availableSectionIds,
  selectedSectionIds,
  sectionColors
) {
  const {fill: fillColor} = sectionsStylesGenerator(
    availableSectionIds,
    selectedSectionIds,
    [],
    unavailableColor,
    sectionColors
  );
  const layerConfig = {
    id: LAYER_SECTIONS_HIGHLIGHTED,
    type: 'fill',
    source: LAYER_SECTIONS_SOURCE,
    'source-layer': getSectionsSourceLayer(venueConfigId),
    maxzoom: sectionsConfig.ZOOM_MAX_SECTIONS,
    minzoom: sectionsConfig.ZOOM_MIN_SECTIONS,
    paint: {
      'fill-opacity': DEFAULT_FILL_OPACITY,
      'fill-color': fillColor,
    },
  };

  return layerConfig;
}

function LayerGASections(sectionsConfig, venueConfigId, unavailableColor, availableSectionIds, selectedSectionIds) {
  const {fill: fillColor} = sectionsStylesGenerator(availableSectionIds, selectedSectionIds, [], unavailableColor, {});
  const layerConfig = {
    id: LAYER_SECTIONS_GA,
    type: 'fill',
    source: LAYER_SECTIONS_SOURCE,
    'source-layer': getSectionsSourceLayer(venueConfigId),
    maxzoom: sectionsConfig.ZOOM_MAX_GA_SECTIONS,
    minzoom: sectionsConfig.ZOOM_MIN_GA_SECTIONS,
    paint: {
      'fill-opacity': DEFAULT_FILL_OPACITY,
      'fill-color': fillColor,
    },
  };

  return layerConfig;
}

function sectionsStylesGenerator(sectionIds, selectedSectionIds, hoveredSectionIds, unavailableColor, sectionColors) {
  if (Array.isArray(sectionIds) && sectionIds.length > 0) {
    const availableSectionsStyle = mapIdsToValueStyle(sectionIds, COLOR_AVAILABLE_SECTION, sectionColors);
    const availableSectionsStyleLines = mapIdsToValueStyle(sectionIds, COLOR_OUTLINE_DEFAULT, sectionColors);

    const fill = ['match', ['get', 'sectionId'], ...availableSectionsStyle, unavailableColor];

    let hover = DEFAULT_HOVER_OPACITY;
    if (Array.isArray(hoveredSectionIds) && hoveredSectionIds.length > 0) {
      const hoveredSectionStyle = mapIdsToValueStyle(hoveredSectionIds, HOVER_OPACITY);
      hover = ['match', ['get', 'sectionId'], ...hoveredSectionStyle, DEFAULT_HOVER_OPACITY];
    }

    if (Array.isArray(selectedSectionIds) && selectedSectionIds.length > 0) {
      const outlineSectionStyle = mapIdsToValueStyle(selectedSectionIds, COLOR_SELECTED_OUTLINE);
      const selectedSectionOutlineWidth = mapIdsToValueStyle(selectedSectionIds, SELECTED_LINE_WIDTH_BASE);
      const selectedSectionOutlineWidthZoom = mapIdsToValueStyle(selectedSectionIds, SELECTED_LINE_WIDTH_ZOOM);

      const line = [
        'match',
        ['get', 'sectionId'],
        ...outlineSectionStyle,
        ['match', ['get', 'sectionId'], ...availableSectionsStyleLines, COLOR_OUTLINE_DEFAULT],
      ];
      const width = [
        'interpolate',
        ['linear'],
        ['zoom'],
        SELECTED_LINE_MIN_ZOOM,
        ['match', ['get', 'sectionId'], ...selectedSectionOutlineWidth, DEFAULT_LINE_WIDTH],
        SELECTED_LINE_MAX_ZOOM,
        ['match', ['get', 'sectionId'], ...selectedSectionOutlineWidthZoom, DEFAULT_LINE_WIDTH],
      ];

      return {fill, line, width, hover};
    }

    return {fill, hover, width: DEFAULT_LINE_WIDTH};
  }

  return {fill: unavailableColor, hover: DEFAULT_HOVER_OPACITY, width: DEFAULT_LINE_WIDTH};
}

export {sectionsStylesGenerator};

export default {
  LayerSections,
  LayerSectionsHighlight: LayerSections,
  LayerSectionsOutline,
  LayerSectionsHover,
  LayerGASections,
};
